import React, { useEffect, useState } from "react";
import Map from "../ThirdpartyLibrary/Map";
import { sendAdminEmail } from "../Services/emailjs/emailService";

function Home({ handleScheduleClick }) {
  useEffect(() => {
    // window.location.reload();
  }, []);

  // Review slider data and logic
  const reviews = [
    {
      text: '"Breakthrough Handyman Services did an excellent job fixing my leaky faucet. They were professional, timely, and the work was done right. I highly recommend their services!"',
      source: "- John D., Phoenix",
      stars: 5,
    },
    {
      text: '"I needed help with some home repairs, and Breakthrough Handyman Services came through. They were responsive, reliable, and the quality of work was outstanding. Will definitely use their services again!"',
      source: "- Sarah M., Scottsdale",
      stars: 5,
    },
    {
      text: '"Great service! They fixed my broken cabinet door and did some other small repairs around the house. Very satisfied with the work and the price. Highly recommend!"',
      source: "- Michael R., Mesa",
      stars: 5,
    },
    // Add more reviews as needed
  ];
  const [currentReview, setCurrentReview] = useState(0);
  const nextReview = () =>
    setCurrentReview((currentReview + 1) % reviews.length);
  const prevReview = () =>
    setCurrentReview((currentReview - 1 + reviews.length) % reviews.length);

  // Email form handler
  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    const form = e.target;
    const email = form.elements[0].value;
    const message = form.elements[1].value;
    try {
      await sendAdminEmail({ email, message });
      // Reset the form fields without refreshing the page
      form.elements[0].value = "";
      form.elements[1].value = "";
    } catch (err) {
      alert("Failed to send message. Please try again later.");
    }
  };

  return (
    <div className="with-navbar-offset">
      <div className="top-bar-wrapper enhanced-top-bar">
        <div className="container">
          <div className="row">
            <div className="col-12 top-bar-info-main enhanced-top-bar-info">
              <span className="lincensed-para enhanced-top-bar-text">
                ⭐ Not a licensed contractor
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Hero Banner Section */}
      <section className="hero-banner-sect" id="banner-sect">
        <div className="hero-banner-sect-wrapper">
          <div className="video-container">
            <video autoPlay muted loop id="myVideo">
              <source
                src="./videos/home-video-compressed.mp4"
                type="video/mp4"
              />
            </video>
          </div>

          <div className="hero-content">
            <div className="container">
              <div className="row">
                <div className="col-lg-8 col-md-10 mx-auto">
                  <div className="hero-text-content">
                    <h1 className="banner-head-text">
                      12,500+ Jobs Done Right. Real Appointments. Real Handymen.
                      Real Results.
                    </h1>
                    <p className="banner-desc-text">
                      Built by customers, for customers. We've helped over 6,000
                      Arizona residents — most more than once — and we're ready
                      to help you too.
                    </p>
                    <div className="hero-cta-group cta-row">
                      <a href="tel:602-938-5415" className="ctaButton primary">
                        📞 Call Now — (602) 938-5415
                      </a>
                      <button
                        className="ctaButton secondary"
                        onClick={handleScheduleClick}
                      >
                        💬 Chat with Alex — Book right here, right now
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Core Trust Section */}
      <section className="core-trust-section">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="section-title trust-title">
                Why Arizona Trusts Us
              </h2>
              <p className="trust-subtitle">
                Real results, real reviews, real reliability.
              </p>
            </div>
            <div className="col-12">
              <div className="trust-points">
                <div className="trust-point-card">
                  <span className="trust-icon">⭐</span>
                  <div className="trust-point-content">
                    <span className="trust-text">
                      <strong>500+ 5-star reviews</strong>
                    </span>
                    <span className="trust-desc">
                      Our customers love us—and keep coming back.
                    </span>
                  </div>
                </div>
                <div className="trust-point-card">
                  <span className="trust-icon">🛠️</span>
                  <div className="trust-point-content">
                    <span className="trust-text">
                      <strong>12,500+ jobs completed</strong>
                    </span>
                    <span className="trust-desc">
                      Experience you can count on, every time.
                    </span>
                  </div>
                </div>
                <div className="trust-point-card">
                  <span className="trust-icon">⚡</span>
                  <div className="trust-point-content">
                    <span className="trust-text">
                      <strong>Same-day or next-day availability</strong>
                    </span>
                    <span className="trust-desc">
                      We're there when you need us—fast.
                    </span>
                  </div>
                </div>
                <div className="trust-point-card">
                  <span className="trust-icon">⏰</span>
                  <div className="trust-point-content">
                    <span className="trust-text">
                      <strong>Real appointment times</strong>
                    </span>
                    <span className="trust-desc">
                      No 4-hour windows. We respect your time.
                    </span>
                  </div>
                </div>
                <div className="trust-point-card">
                  <span className="trust-icon">👍</span>
                  <div className="trust-point-content">
                    <span className="trust-text">
                      <strong>No payment until you're happy</strong>
                    </span>
                    <span className="trust-desc">
                      Satisfaction guaranteed, every job.
                    </span>
                  </div>
                </div>
                <div className="trust-point-card">
                  <span className="trust-icon">💵</span>
                  <div className="trust-point-content">
                    <span className="trust-text">
                      <strong>Honest pricing</strong>
                    </span>
                    <span className="trust-desc">
                      No material markup. No surprises.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Mid-page Feature */}
      <section className="mid-page-feature">
        <div className="container text-center">
          <h2>Let Alex quote & book your job right now.</h2>
          <button className="ctaButton" onClick={handleScheduleClick}>
            Get Started with Alex →
          </button>
        </div>
      </section>

      {/* Our Guarantee Section */}
      <section className="guarantee-section">
        <div className="container">
          <h2 className="section-title">Built on Doing Right</h2>
          <p className="guarantee-subtitle">
            Our promises to you—no fine print, just real guarantees.
          </p>
          <div className="guarantee-points">
            <div className="guarantee-card">
              <span className="guarantee-icon">⏰</span>
              <div className="guarantee-content">
                <span className="guarantee-title">
                  <strong>Real appointment times</strong>
                </span>
                <span className="guarantee-desc">
                  No "arrival windows"—we show up when we say we will.
                </span>
              </div>
            </div>
            <div className="guarantee-card">
              <span className="guarantee-icon">📲</span>
              <div className="guarantee-content">
                <span className="guarantee-title">
                  <strong>Instant updates</strong>
                </span>
                <span className="guarantee-desc">
                  If we're running late, you'll know the moment we know.
                </span>
              </div>
            </div>
            <div className="guarantee-card">
              <span className="guarantee-icon">💬</span>
              <div className="guarantee-content">
                <span className="guarantee-title">
                  <strong>Transparent pricing</strong>
                </span>
                <span className="guarantee-desc">
                  You'll always know the price before work continues.
                </span>
              </div>
            </div>
            <div className="guarantee-card">
              <span className="guarantee-icon">💸</span>
              <div className="guarantee-content">
                <span className="guarantee-title">
                  <strong>Pay less if it takes less time</strong>
                </span>
                <span className="guarantee-desc">
                  We bill in half hour increments based on the actual time
                </span>
              </div>
            </div>
            <div className="guarantee-card">
              <span className="guarantee-icon">🛠️</span>
              <div className="guarantee-content">
                <span className="guarantee-title">
                  <strong>We own our mistakes</strong>
                </span>
                <span className="guarantee-desc">
                  If something goes wrong, we fix it—no excuses.
                </span>
              </div>
            </div>
            <div className="guarantee-card">
              <span className="guarantee-icon">👍</span>
              <div className="guarantee-content">
                <span className="guarantee-title">
                  <strong>Pay only when satisfied</strong>
                </span>
                <span className="guarantee-desc">
                  You don't pay until the job is done and you're happy.
                </span>
              </div>
            </div>
            <div className="guarantee-card">
              <span className="guarantee-icon">👷‍♂️</span>
              <div className="guarantee-content">
                <span className="guarantee-title">
                  <strong>Pro handymen</strong>
                </span>
                <span className="guarantee-desc">
                  Full-time, skilled, and serious about their craft.
                </span>
              </div>
            </div>
          </div>
          <div className="quote-block guarantee-quote-block">
            <p>
              <span className="quote-mark">"</span>Perfection on every job is
              impossible... make it right and take care of the customer, THAT is
              our promise.
              <span className="quote-mark">"</span>
            </p>
          </div>
        </div>
      </section>

      {/* Why We're Different Section
      <section className="why-different-section">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="section-title">Why We're Different</h2>
              <h3 className="section-subtitle">
                We're Not Just Another Handyman Company — We're a Promise Kept,
                Over 12,500 Times.
              </h3>
              <div className="section-description">
                <p>
                  Our numbers tell the story: over 12,500 verified jobs
                  completed for just 6,037 customers.
                </p>
                <p>
                  Why so few? Because people trust us — and they come back again
                  and again.
                </p>
                <p>
                  We've been in business over 5 years and now, we're doing what
                  most won't: lowering our prices.
                </p>
                <p>Not because we have to — because we want to help.</p>
              </div>
            </div>
          </div>
        </div>
      </section> */}

      {/* Our Story Section */}
      <section className="our-story-section enhanced-story-section">
        <h2 className="section-title story-main-title">Our Story</h2>
        <h3 className="story-title">
          🔥 We Got Burned — So We Built Something Better
        </h3>
        <p className="story-subtitle">
          Before Breakthrough Handyman ever existed, we were just like you.
        </p>
        <div className="story-gallery enhanced-story-gallery">
          <img
            src="./images/story-1.jpg"
            alt="Handyman at work"
            className="story-photo enhanced-story-photo"
          />
          <img
            src="./images/story-2.jpg"
            alt="Team with tools"
            className="story-photo enhanced-story-photo"
          />
          <img
            src="./images/story-3.jpg"
            alt="Service truck"
            className="story-photo enhanced-story-photo"
          />
        </div>
        <div className="story-card enhanced-story-card">
          <div className="story-icon">🔥</div>
          <div className="story-content">
            <p>
              We were property managers, real estate agents, and homeowners
              trying to get reliable help — and constantly getting burned.
              No-shows. Ghosted bids. Sloppy work. Handymen who disappeared
              halfway through a job or never showed up at all.
            </p>
            <p>
              We knew there had to be a better way — one built on respect,
              reliability, and real accountability.
            </p>
            <p>So we started Breakthrough Handyman.</p>
            <p>
              Family-owned and proudly local, our mission from day one has been
              to protect both homeowners and handymen. We built a system that
              gives our handymen the structure, support, and full-time
              opportunity they deserve — while giving customers the consistency,
              quality, and clear communication they've always wanted.
            </p>
            <p>No vague windows. No fly-by-night guys. No surprises.</p>
            <p>
              Just honest, hard work — backed by real appointment times, simple
              pricing, and handymen you'll actually want to invite back.
            </p>
            <p>
              <span className="story-highlight">
                Because we've been burned too. And we decided enough was enough.
              </span>
            </p>
          </div>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="how-it-works-section">
        <div className="container">
          <h2 className="section-title">Simple. Honest. Effective.</h2>
          <p className="howit-subtitle">
            How easy it is to get your job done right with us:
          </p>
          <div className="steps-container">
            <div className="step-card">
              <div className="step-icon step-1">1</div>
              <div className="step-label">Tell us what you need</div>
            </div>
            <div className="step-card">
              <div className="step-icon step-2">2</div>
              <div className="step-label">
                Alex gives you an estimated time, cost, and options
              </div>
            </div>
            <div className="step-card">
              <div className="step-icon step-3">3</div>
              <div className="step-label">
                Pick a real appointment time — no waiting around
              </div>
            </div>
            <div className="step-card">
              <div className="step-icon step-4">4</div>
              <div className="step-label">
                Your handyman shows up, confirms scope, and gets to work
              </div>
            </div>
            <div className="step-card">
              <div className="step-icon step-5">5</div>
              <div className="step-label">They walk you through the result</div>
            </div>
            <div className="step-card">
              <div className="step-icon step-6">6</div>
              <div className="step-label">
                You approve the work and pay when you're happy
              </div>
            </div>
          </div>
          <div className="steps-progress-line"></div>
          <div className="policies-section">
            <h3>Why We Have Policies</h3>
            <div className="policy-points">
              <div className="policy-point">
                <div className="policy-icon" aria-label="Cancellation Fees">
                  ⏳
                </div>
                <h4>Cancellation Fees</h4>
                <p>Protect time & guarantee availability</p>
              </div>
              <div className="policy-point">
                <div className="policy-icon" aria-label="Late Fees">
                  ⏰
                </div>
                <h4>Late Fees</h4>
                <p>
                  We run a tight schedule to serve every customer — including
                  you
                </p>
              </div>
              <div className="policy-point">
                <div className="policy-icon" aria-label="Payment Terms">
                  💳
                </div>
                <h4>Payment Terms</h4>
                <p>Pay only after you're satisfied</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Pricing Section */}
      <section className="pricing-section">
        <div className="container">
          <div className="pricing-header">
            <h2 className="section-title">Simple, Transparent Pricing</h2>
            <p className="section-subtitle">
              No hidden fees. No surprises. Just honest, reliable service.
            </p>
          </div>

          <div className="pricing-cards-row">
            <div className="pricing-card new-pricing-card">
              <div className="pricing-icon">⏰</div>
              <div className="price-main">
                <span className="currency">$</span>
                <span className="amount">79</span>
              </div>
              <div className="price-label">First Hour</div>
            </div>
            <div className="price-divider-large">→</div>
            <div className="pricing-card new-pricing-card">
              <div className="pricing-icon">🔁</div>
              <div className="price-main">
                <span className="currency">$</span>
                <span className="amount">69</span>
                <span className="period">/hr</span>
              </div>
              <div className="price-label">After First Hour</div>
            </div>
          </div>

          <div className="pricing-features-grid">
            <div className="feature-item">
              <span className="check">✓</span> Licensed & Insured Professionals
            </div>
            <div className="feature-item">
              <span className="check">✓</span> Same-Day Service Available
            </div>
            <div className="feature-item">
              <span className="check">✓</span> No Markup on Materials
            </div>
            <div className="feature-item">
              <span className="check">✓</span> 100% Satisfaction Guarantee
            </div>
            <div className="feature-item">
              <span className="check">✓</span> Real Appointment Times
            </div>
            <div className="feature-item">
              <span className="check">✓</span> Pay Only When Satisfied
            </div>
          </div>

          <div className="pricing-trust-badges">
            <span className="trust-badge">🔒 No Markup on Materials</span>
            <span className="trust-badge">⭐ Full-Time Professionals</span>
            <span className="trust-badge">💯 100% Satisfaction Guarantee</span>
          </div>

          <div className="pricing-cta">
            <button className="ctaButton primary" onClick={handleScheduleClick}>
              Book Your Service
            </button>
            <p className="pricing-note">
              Get a free quote for your specific job
            </p>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-section">
        <div className="container">
          <div className="contact-header">
            <h2 className="section-title">Contact Us</h2>
            <p className="section-subtitle">
              Choose the way that works best for you
            </p>
          </div>
          <div className="contact-options">
            <div className="contact-option">
              <div className="contact-icon" aria-label="Call">
                📞
              </div>
              <h3>Call — Fastest response</h3>
              <a href="tel:602-938-5415" className="ctaButton contact-action">
                602-938-5415
              </a>
              <p className="contact-note">Average response: 5 minutes</p>
            </div>
            <div className="contact-option">
              <div className="contact-icon" aria-label="Chat">
                💬
              </div>
              <h3>Alex — Chat 24/7</h3>
              <ul className="contact-features">
                <li>
                  <span className="check">✓</span> Get instant quotes
                </li>
                <li>
                  <span className="check">✓</span> Book full jobs
                </li>
                <li>
                  <span className="check">✓</span> Ask questions
                </li>
              </ul>
              <button
                className="ctaButton contact-action"
                onClick={handleScheduleClick}
              >
                Chat with Alex
              </button>
            </div>
            <div className="contact-option">
              <div className="contact-icon" aria-label="Email">
                ✉️
              </div>
              <h3>Email</h3>
              <form className="contact-form" onSubmit={handleEmailSubmit}>
                <input type="email" placeholder="Your email" required />
                <textarea placeholder="Your message" required></textarea>
                <button type="submit" className="ctaButton contact-action">
                  Send Message
                </button>
              </form>
            </div>
          </div>
          <div className="contact-hours-block">
            <h4>Business Hours</h4>
            <div className="contact-hours-list">
              <span>Mon–Fri: 7:00 AM – 7:00 PM</span>
              <span>Sat: 8:00 AM – 5:00 PM</span>
              <span>Sun: Closed</span>
            </div>
            <div className="contact-hours-note">
              Extended hours available during summer months (90°+)
            </div>
          </div>
        </div>
      </section>

      {/* Social Proof Section */}
      <section className="social-proof-section">
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2 className="section-title">
                Why Do Thousands Keep Coming Back? Because We Show Up, Do It
                Right, and Keep It Honest.
              </h2>
              <div className="proof-points">
                <div className="proof-point">
                  <div className="proof-number">12,500+</div>
                  <div className="proof-text">Verified Jobs</div>
                </div>
                <div className="proof-point">
                  <div className="proof-number">5+</div>
                  <div className="proof-text">Years in Business</div>
                </div>
                <div className="proof-point">
                  <div className="proof-number">6,037</div>
                  <div className="proof-text">Valued Customers</div>
                </div>
                <div className="proof-point">
                  <div className="proof-number">100%</div>
                  <div className="proof-text">Work Guaranteed</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sticky Banner */}
      {/* <div className="sticky-banner">
        <div className="container">
          <p className="banner-text">
            Prices Lowered to Help You Get More Done. $79 First Hour. $69 After.
          </p>
          <button className="ctaButton" onClick={handleScheduleClick}>
            Book Now →
          </button>
        </div>
      </div> */}

      {/* Milestones Section */}
      <section className="milestones-section">
        <div className="container text-center">
          <h2 className="milestones-title">Milestones That Matter</h2>
          <p className="milestones-description">
            Join our family of over <strong>6,000 happy customers</strong>{" "}
            who've trusted us with more than{" "}
            <strong>12,500 successful projects</strong>. Our customers love us
            so much, they keep coming back!
          </p>
          <button className="ctaButton" onClick={handleScheduleClick}>
            Get Your Free Quote →
          </button>
        </div>

        <div className="milestone-banner">
          <p className="milestone-text">
            <span>Over 12,500 Appointments & Counting!</span>
            <br />
            Celebrating 5 years of trusted service in Maricopa County
            <br />
            <span>Call </span>
            <span className="top-bar-text-link milestone-contact">
              <img
                src="https://breakthroughhandyman.com/wp-content/themes/breakthrough/images/topbar-phone-icon.png"
                alt=""
                className="top-bar-img"
              />

              <a href="tel:602-938-5415" className="top-bar-phone">
                602-938-5415
              </a>
              <span className="top-bar-second-text">
                {" "}
                Or click below to book instantly!
              </span>
            </span>
          </p>
        </div>
      </section>

      {/* Testimonials Section */}
      <section className="testimonials-section">
        <div className="container text-center">
          <h2 className="testimonials-title">What Our Customers Say</h2>
          <div className="review-slider">
            <button
              className="slider-arrow left"
              onClick={prevReview}
              aria-label="Previous Review"
            >
              &#8592;
            </button>
            <div className="testimonial-card slider-card">
              <div className="stars">
                {"★".repeat(reviews[currentReview].stars)}
              </div>
              <p className="testimonial-quote">{reviews[currentReview].text}</p>
              <p className="testimonial-source">
                {reviews[currentReview].source}
              </p>
            </div>
            <button
              className="slider-arrow right"
              onClick={nextReview}
              aria-label="Next Review"
            >
              &#8594;
            </button>
          </div>
          <div className="testimonial-cta">
            <button className="ctaButton" onClick={handleScheduleClick}>
              Book Your Service →
            </button>
          </div>
        </div>
      </section>

      {/* Legal Pages Section */}
      <section className="legal-section">
        <div className="container">
          <h2 className="section-title legal-title">
            Your trust and privacy are our top priorities.
          </h2>
          <p className="legal-subtitle">
            Please review our key policies below.
          </p>
          <div className="legal-cards">
            <div className="legal-card">
              <div className="legal-icon" aria-label="Terms & Conditions">
                📄
              </div>
              <h3>Terms & Conditions</h3>
              <ul>
                <li>Clear pricing, payment, and cancellation policies</li>
                <li>Warranty scope and customer expectations</li>
                <li>Easy rescheduling and transparent terms</li>
              </ul>
            </div>
            <div className="legal-card">
              <div className="legal-icon" aria-label="Privacy Policy">
                🔒
              </div>
              <h3>Privacy Policy</h3>
              <ul>
                <li>Data collected via chatbot, contact forms, and cookies</li>
                <li>No sharing with third parties</li>
                <li>Your privacy is always protected</li>
              </ul>
            </div>
            <div className="legal-card">
              <div className="legal-icon" aria-label="Disclaimer">
                ⚖️
              </div>
              <h3>Disclaimer</h3>
              <ul>
                <li>
                  Handymen are independent but trained & held to Breakthrough's
                  standards
                </li>
                <li>Warranty details and limitations explained</li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <Map />
    </div>
  );
}

export default Home;
